import { render, staticRenderFns } from "./MOAAgreement.vue?vue&type=template&id=3fe49e42&scoped=true&"
import script from "./MOAAgreement.vue?vue&type=script&lang=js&"
export * from "./MOAAgreement.vue?vue&type=script&lang=js&"
import style0 from "./MOAAgreement.vue?vue&type=style&index=0&id=3fe49e42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe49e42",
  null
  
)

export default component.exports